<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

		
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索等級名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">添加等級</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button>
				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="等級名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索等級名稱"></el-input>
						</el-form-item>
					
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center"></el-table-column>
				
				<el-table-column align="center" prop="level" label="等級">
				</el-table-column>

				<el-table-column align="center" prop="name" label="等級名稱">
				</el-table-column>

				<el-table-column align="center"  prop="up_score" label="升級需要的分數">
				</el-table-column>

                <el-table-column align="center"  prop="send_diamond" label="升級贈送鑽石">
				</el-table-column>

				<el-table-column align="center"  prop="send_coin" label="升級贈送金幣">
				</el-table-column>

				<el-table-column align="center" prop="user_count" label="等級對應人數">
				</el-table-column>
		
				<el-table-column align="center" width="280"   prop="create_time" label="創建時間">
				</el-table-column>

				<el-table-column align="center" width="280"   prop="update_time" label="修改時間">
				</el-table-column>

				<el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">操作</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex > -1 ? '修改等級' : '添加等級'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'130px'">

				<el-form-item label="等級" prop="level">
					<el-input  v-model="form.level" type="number" placeholder="等級"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="等級名稱" prop="name">
					<el-input  v-model="form.name" type="text" placeholder="等級名稱"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="升級需要的分數" prop="up_score">
					<el-input  v-model="form.up_score" type="number" placeholder="升級需要的分數"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="升級贈送鑽石" prop="send_diamond">
					<el-input  v-model="form.send_diamond" type="number" placeholder="升級贈送鑽石"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="升級贈送金幣" prop="send_coin">
					<el-input  v-model="form.send_coin" type="number" placeholder="升級贈送金幣"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name:'',
				},
				model_title: 'Level',
				auth_val: 'Level',
				preUrl: "data/levelList", //列表地址
				delAllUrl: "data/delLevelAll", //批量删除地址
				delUrl: "data/delLevel", //删除單条地址
				addUrl: "data/addLevel", //添加/修改地址

				tableData: [],
				form: {
					id:0,
					level:0,
					name:'',
					up_score:0,
					send_diamond:0,
					send_coin:0,
				},
				rules: {
					name: [{
							required: true,
							message: "等級名稱不能為空",
							trigger: 'blur',
						},
					],
					level: [
                        {
                            required: true,
                            message: "等級不能為空",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value <= 0) {
                                    callback(new Error('等級不能小於或等於0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],
                    up_score: [
                        {
                            required: true,
                            message: "升級需要的分數不能為空",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value <= 0) {
                                    callback(new Error('升級需要的分數不能小於或等於0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],
                    send_coin: [
                        {
                            required: true,
                            message: "升級贈送金幣不能為空",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value < 0) {
                                    callback(new Error('升級贈送金幣不能小於0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],
					send_diamond: [
                        {
                            required: true,
                            message: "升級贈送鑽石不能小於0",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value < 0) {
                                    callback(new Error('升級贈送鑽石不能小於0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],

				},
				prop: 'level',
				sort: 'ascending',
				subject_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		methods: {
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
					}
				})
			},
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						level:0,
						name:'',
						up_score:0,
						send_diamond:0,
						send_coin:0,
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.row.id,
						level: e.row.level,
						name:e.row.name,
						up_score:e.row.up_score,
						send_diamond: e.row.send_diamond,
						send_coin: e.row.send_coin,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
				}
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			
		}
	}
</script>

<style>
</style>
